<template>
   <v-form ref="changePasswordForm" onsubmit="return false;">
        <v-text-field
            outline
            color="secondary"
            :label="$t('rms.field.password.label')"
            name="new_password"
            :placeholder="$t('rms.field.password.label')"
            :rules="[
            rules.required,
            rules.min_length(6),
            rules.englishCharacters,
            ]"
            prepend-inner-icon="lock"
            type="password"
            v-model="password"
        ></v-text-field>
        <v-text-field
            outline
            id="confirm_password"
            color="secondary"
            :label="$t('rms.field.confirm_password.label')"
            name="confirm_password"
            :placeholder="$t('rms.field.confirm_password.label')"
            :rules="[
            rules.required,
            rules.min_length(6),
            rules.englishCharacters,
            ]"
            prepend-inner-icon="lock"
            type="password"
            v-model="confirm_password"
        ></v-text-field>
    </v-form>
</template>

<script>
import DEFINES from "@/defines";
import rules from "@/validation";
export default {
    name:"changePassword",
    data(){
        return{
            rules,
            password:null,
            confirm_password:null
        }
    },
   watch:{
        password: {
            handler: function () {
                this.$emit("update:password", this.password);
            }
        },
        confirm_password: {
            handler: function () {
                this.$emit("update:confirm_password", this.confirm_password);
            }
        },
   },
    methods: {
        reset() {
            this.$refs.changePasswordForm.reset();
        },
        validate() {
            return this.$refs.changePasswordForm.validate();
        },
  },
}
</script>

<style>

</style>
